module.exports = __webpack_public_path__ + "img/guanggao.4a5a7bf5.jpg";